import get from "lodash/get";
import { useMemo } from "react";

export function useMapToId<T>(data: T[], keyField = "id", transform?: (d: T) => T) {
  return useMemo(() => {
    const result: Record<string, T> = {};
    Object.values(data).forEach((item) => {
      const key = get(item, keyField, "");

      if (transform) {
        result[key] = transform(item);
      } else {
        result[key] = item;
      }
    });
    return result;
  }, [data, keyField, transform]);
}
